module.exports = "<div class=\"col-2\">\r\n  <button class=\"btn btn-primary btn-sm\" type=\"button\" (click)=\"open()\">\r\n    {{ label | i18next }}\r\n  </button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/shared/modal.text.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/shared/modal.text.component.html
// module chunks = main